<template>
  <div  class="main-container">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <div>
      <menu-superior :link="'/'+this.$store.state.empresa_url + '/menu'" :titulo="$t('meus_pedidos')"></menu-superior>
    <bloco>
      <titulo-destacado :titulo="$t('ultimos_pedidos_na_loja')">
        <span class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div v-for="(item, index) in this.pedidos" :key="index">
        <div class="itemb cor-primaria-border card-pedido" style="display: flex;">
          <div style=" width: 90%;">
            <div class="flex justify-between">
              <p class="splash-cor-1 font-semibold font-sans tracking-wide text-sm" style="margin-top: -5px;">#{{ item.numero_pedido }}
                  <br>
                  <span  class="splash-cor-1"  :id="'card-tempo' + item.id "><b>{{ $t('data') }}:</b> {{ (formatarData(item.created_at))}}</span>
                  <br>
                  <span  class="splash-cor-1"  :id="'card-tempo' + item.id "><b>{{ $t('total') }}:</b> R$ {{ (item.valor_total)}}</span>
                  <br>
                  <badge :color="badgeColor(item)"><b>{{ $t('status') }}:</b> {{ getFriendlyStatus(item.status) }}</badge>
              </p>
            </div>
          </div>
          <div style="width: b 10%; justify-content: left; display: flex; align-items: center; margin-right: 15px;">
            <div class=" flex justify-between btn-group btn-group-sm" role="group" aria-label="Detalhes" align="right">
              <button  
                @click="DetalhesPedido(item.numero_pedido)" 
                type="button" 
                class="btn btn-light cor-primaria-bg" 
                data-toggle="modal"
                      data-target="#staticBackdrop">
                  <i class="fas fa-eye"></i>
                  <!-- Visualizar -->
              </button>
            </div>
          </div>
        </div>        
      </div>
    </bloco>
    </div>
  </div>
</template>

<script>
import MenuSuperior from "../../Widgets/MenuSuperior";
import Bloco from "../../Widgets/Bloco";
import TituloDestacado from "../../Widgets/TituloDestacado";
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";
import Loading from "vue-loading-overlay";
import Badge from "../../Widgets/Badge.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import {ObterClienteLogado} from "../../../services/auth";
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';

export default {
  name: "PedidosCliente",
  components: {
    LogoEmpresa,
    NavBarOnly,
    Loading,
    TituloDestacado, Bloco, MenuSuperior, Badge
  },
  mounted() {
    // Se a empresa desativou "acompanhar último pedido", bloqueia também a área de "Meus Pedidos"
    this.$watch(
      () => (this.$store && this.$store.state && this.$store.state.empresa)
        ? this.$store.state.empresa.desativar_acompanhar_ultimo_pedido
        : null,
      (flag) => {
        if (String(flag || "N").trim().toUpperCase() === "S") {
          this.$router.replace("/" + this.$store.state.empresa_url + "/menu");
        }
      },
      { immediate: true }
    );

    window.scrollTo(0, 0);
    ObterClienteLogado().then(res=>{
      this.cliente = res;
    }).catch(err=>{
      console.log('erro')
    }); 
    this.VerificarEmpresa().then(()=>{
        if(this.$store.state.pedido.itens.length == 0){
          this.ObterPedidos();
        }
      });   
  },
  data() {
    return {
      cliente: {},
      isLoading: false,
      lastError: null,
      clienteLogado: false,
      fullPage: true,
      pedidos: []
    };
  },
  methods: {
    getFriendlyStatus(status) {
        switch (status) {
            case 'AGUARDANDO':
                return this.$t('aguardando');
            case 'RECEBIDO':
                return this.$t('recebido');
            case 'CANCELADO':
                return this.$t('cancelado');
            case 'ENVIADO':
                return this.$t('enviado');
            case 'PREPARANDO':
                return this.$t('preparando');
            case 'ENTREGUE':
                return this.$t('entregue');
            case 'PROCESSANDO_PAGAMENTO':
                return this.$t('processando_pagamento');
            case 'PRONTOPARARETIRADA':
                return this.$t('pronto_para_retirada');
            case 'PRONTOPARAENTREGA':
                return this.$t('pronto_para_entrega');
            case 'ENDERECO_NAO_LOCALIZADO':
                return this.$t('endereco_nao_localizado');
            case 'RECUSOU_RECEBER':
                return this.$t('recusou_receber');
            default:
                return this.$t('status_desconhecido');
        }
    },
    ShowStatus(status) {
            let statusCustomizado = status;
            switch (status) {
                case 'PRONTOPARAENTREGA':
                    statusCustomizado = 'PRONTO';
                    break;
                case 'PRONTOPARARETIRADA':
                    statusCustomizado = 'PRONTO';
                    break;
            }
            return statusCustomizado;
    },
    badgeColor(item) {
            const mappings = {
                "PREPARANDO": "purple",
                "RECEBIDO": "blue",
                "PRONTOPARAENTREGA": "teal",
                "ENTREGUE": "green",
                "ENVIADO": "teal",
                "PRONTOPARARETIRADA": "green",
                default: "teal"
            };
            return mappings[item.status] || mappings.default;
    },
    async VerificarEmpresa() {
      this.isLoading = true;
      this.$store.commit("empresaUrl", this.$router.currentRoute.params.empresa);
      
      const buscarEmpresa = async (tentativa = 1) => {
        try {
          const res = await axios.get(
            this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url
          );
          
          if (res.data) {
            this.$store.commit("empresa", res.data);
            this.empresaExiste = true;
            this.isLoading = false;
            return true;
          }
          return false;
        } catch (error) {
          if (tentativa < 5) {
            console.log(`Tentativa ${tentativa} de buscar empresa falhou, tentando novamente em 1.5s...`, error.response && error.response.status);
            await new Promise(resolve => setTimeout(resolve, 1500));
            return buscarEmpresa(tentativa + 1);
          }
          this.lastError = error;
          this.isLoading = false;
          return false;
        }
      };

      const sucesso = await buscarEmpresa();

      if (!sucesso && !this.empresaExiste) {
        let reason = this.lastError ? (this.lastError.message || this.lastError) : 'Unknown';
        if (this.lastError && this.lastError.response) {
            reason += ` (Status: ${this.lastError.response.status})`;
        }
        reason += ` | Slug: ${this.$store.state.empresa_url}`;
        this.$router.push({
          path: '/404/nao-localizado',
          query: { retryPath: this.$route.fullPath, reason: reason }
        });
      }
    },
    async ObterPedidos() {
      try {
        this.isLoading = true;
        let cliente = await ObterClienteLogado().catch(err => {
          console.error("Erro ao obter cliente:", err);
          return null;
        });

        if (!cliente || !this.$store.state.empresa.id || !cliente.id) {
          const targetRoute = '/' + this.$router.currentRoute.params.empresa + '/menu';
          if (this.$router.currentRoute.path !== targetRoute) {
            this.$router.push(targetRoute);
          }
          return;
        }

        const response = await axios.post(this.$store.state.apiUrl + "cliente/pedidos", {
          empresa_id: this.$store.state.empresa.id,
          cliente_id: cliente.id,
          telefone: cliente.telefone
        });

        if (response.data && Array.isArray(response.data)) {
          this.pedidos = response.data;
        } else {
          this.pedidos = [];
        }
      } catch (error) {
        console.error("Erro ao obter pedidos:", error.response ? error.response.data : error.message);
        this.pedidos = [];
      } finally {
        this.isLoading = false;
      }
    },
      formatarData(dataISO) {
        const data = new Date(dataISO);
        
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0'); // Mês começa em 0, por isso o +1
        const ano = data.getFullYear();

        return `${dia}/${mes}/${ano}`;
      },
      DetalhesPedido(pedido){
        if(pedido){
        let chave = CryptoJS.MD5(pedido).toString();
        Cookies.set(chave, btoa(pedido.toString()), { expires: 3 });
        window.open('/' + this.$router.currentRoute.params.empresa + '/pedido/status/' + CryptoJS.MD5(pedido).toString(), '_blank');
      }
      },
      ConsultarStatusPagamentoPagHiper() {
        let chaveRastreamento = this.paghiper_pix.chave_rastreamento;
        $.ajax({
          url: this.$store.state.apiUrl + "paghiper/consultar-pagamento-pix/" + chaveRastreamento,
          type: "GET",
          success: (data) => {
              if(data.status == 'PAGO'){
                this.paghiper_pix.pagamento_realizado = true;
                clearInterval(this._paghiper_checar_pagamento_intervalo);
                // this.EnviarPedido();
                // this.ConfirmarPagamentoPedido()
              }
          },
          error: (data) => {

          }
        });
      },
  }
};
</script>

<style scoped>
  @import '../../../assets/css/conteudo-splash.css';
  @import '../../../assets/css/paginas-inicio.css';


  .card-pedido{
    border:  1px solid;
    margin: 5px;
    padding: 5px;
    border-radius: 15px;
  }

  .main-container {
  height: 100vh; /* Ocupa a altura total da tela */
  overflow-y: auto; /* Permite rolagem vertical */
}

  
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/PedidosCliente.vue